import React from "react";

export default function ImageWithFallback({ url, className = "", ...props }) {
  const fallback = "/images/no-image-placeholder.png";
  const classList = `${className} ${!url ? "image-placeholder" : ""}`;
  return <img src={url || fallback} alt="" {...props} className={classList} />;
}
